import './loading-indicator.component.scss';

export function LoadingIndicator(props: { 'class'?: string }) {
	return <div class={'loading-indicator ' + (props.class || '')}>
		<div class="loader"></div>
	</div>;
}
